<template>
  <div class="hidden laptop:flex items-center justify-between laptop:w-9/12 h-full w-1/2">
    <MenuItem
      v-for="menuItem in menuItems"
      :key="menuItem.key"
      :menu-item="menuItem"
      :is-active="activeSubmenu === menuItem.key"
      :menu-ref="(el: Element | null) => { menuRefs[menuItem.key] = el as HTMLAnchorElement | null }"
      @menu-click="$emit('menuClick', $event)"
      @menu-hover="$emit('menuHover', $event)"
      @menu-leave="$emit('menuLeave')"
    />
  </div>
</template>

<script setup lang="ts">
import MenuItem from './MenuItem.vue'
import type { MenuItem as MenuItemType } from '../types/navigation'

interface Props {
  menuItems: MenuItemType[]
  activeSubmenu: string | null
  menuRefs: { [key: string]: HTMLAnchorElement | null }
}

defineProps<Props>()

defineEmits<{
  menuClick: [menuItem: MenuItemType]
  menuHover: [menuItem: MenuItemType]
  menuLeave: []
}>()
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

